import { Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { ConsignmentContractRecord, SalesApiService } from './sales-api.service';

@Component({
  standalone: true,
  selector: 'ain-sales-consignment-contracts',
  imports: [AinPageComponent, AinStateComponent, FormsModule, TableModule, ButtonModule],
  template: `
    <ain-page [title]="t('sales.consignments.title')" [description]="t('sales.consignments.description')">
      @if (loading()) { <ain-state type="loading" [title]="t('common.loading')" /> } @else {
        <section class="panel">
          <div class="toolbar">
            <button pButton type="button" [label]="t('sales.action.create')" (click)="openCreate()"></button>
            <button pButton type="button" [label]="t('sales.action.edit')" severity="secondary" [disabled]="selectedRows().length !== 1" (click)="openSelected()"></button>
            <button pButton type="button" [label]="t('sales.action.refresh')" severity="secondary" (click)="load()"></button>
          </div>
          <p-table [value]="rows()" dataKey="id" [paginator]="true" [rows]="15" [selection]="selectedRows()" (selectionChange)="onSelectionChange($event)">
            <ng-template pTemplate="header">
              <tr><th style="width:44px"><p-tableHeaderCheckbox /></th><th>{{ t('sales.consignments.fields.contractNumber') }}</th><th>{{ t('columns.status') }}</th></tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td><p-tableCheckbox [value]="row" /></td>
                <td><button type="button" class="link-btn" (click)="openDetail(row.id)">{{ row.contractNumber }}</button></td>
                <td>{{ row.status }}</td>
              </tr>
            </ng-template>
          </p-table>
        </section>
      }
    </ain-page>
  `,
  styles: [`.panel{display:grid;gap:10px}.toolbar{display:flex;gap:8px}.link-btn{border:0;background:none;color:#1d4ed8;font-weight:600;padding:0}`]
})
export class SalesConsignmentContractsComponent implements OnInit {
  private readonly api = inject(SalesApiService);
  private readonly router = inject(Router);
  private readonly localization = inject(LocalizationService);
  readonly loading = signal(true);
  readonly rows = signal<ConsignmentContractRecord[]>([]);
  readonly selectedRows = signal<ConsignmentContractRecord[]>([]);
  ngOnInit(): void { this.load(); }
  load(): void { this.api.listConsignmentContracts().subscribe({ next: r => { this.rows.set(r); this.loading.set(false); } }); }
  onSelectionChange(s: ConsignmentContractRecord[] | ConsignmentContractRecord | null): void { this.selectedRows.set(Array.isArray(s) ? s : s ? [s] : []); }
  openCreate(): void { void this.router.navigate(['/sales/consignment-contracts/new']); }
  openSelected(): void { const r = this.selectedRows()[0]; if (r) this.openDetail(r.id); }
  openDetail(id: string): void { void this.router.navigate(['/sales/consignment-contracts', id]); }
  t(key: string): string { return this.localization.translate(key); }
}
